const tableCellCompany = {
  logo: 'LOGO'
};

export default tableCellCompany;
